import { z } from 'zod';

import {
  ShineAccountingExportFormat,
  ShineRecurringAccountingExportSettingsCadence,
  ShineRecurringAccountingExportSettingsType,
} from '__generated__/GQL';
import zodLocales from 'common/zod/locales';

export const accountingExportSchema = z.discriminatedUnion('type', [
  z.object({
    cadence: z.nativeEnum(ShineRecurringAccountingExportSettingsCadence),
    cadenceOffset: z.number().int(),
    formats: z.array(z.nativeEnum(ShineAccountingExportFormat)),
    includeBankStatements: z.boolean(),
    includeInvoices: z.boolean(),
    includePersonalTransactions: z.boolean(),
    recipients: z
      .array(z.string().email({ message: zodLocales.errors.invalidEmail }))
      .nonempty({ message: zodLocales.errors.required }),
    type: z.literal(ShineRecurringAccountingExportSettingsType.ShineRecurring),
  }),
]);

export type AccountingExportSchema = z.infer<typeof accountingExportSchema>;

export type ShineRecurringAccountingExportSchema = z.infer<
  typeof accountingExportSchema
> & {
  type: ShineRecurringAccountingExportSettingsType.ShineRecurring;
};
